import React, { useEffect } from "react";
import { DealsQuestionnaireData, Responses, Score } from "@/pages/deals/types";
import SingleSelectQuestion from "@/components/controls/Questions/SingleSelectQuestion";
import { useDeals } from "@/pages/deals/hooks";
import { useResetPeopleInfinite } from "@/entities/people/hooks";
import { useResetAPI } from "@/services/api/hook";
import { map } from "lodash";
import { useQuestionnaireResponses } from "@/hooks/useQuestionnaireResponses";
interface Props {
  dealId: string;
  questionnaire: DealsQuestionnaireData;
  handleUpdateQuestionnaireScore: (newValue: Score | null) => void;
  responses?: Responses;
}

const MappingQuestionnaire: React.FC<Props> = ({
  dealId,
  questionnaire,
  handleUpdateQuestionnaireScore,
  responses
}) => {
  const { questions } = questionnaire;

  const orderedQuestions = questions?.sort(
    (a, b) => (a.questionOrder ?? 0) - (b.questionOrder ?? 0)
  );
  const resetPeopleInfinite = useResetPeopleInfinite();
  const resetPeopleInCompany = useResetAPI("people/company", false, "", dealId);

  const { localResponses, updateResponse, resetResponses } =
    useQuestionnaireResponses(responses);

  const {
    entities: [dealData]
  } = useDeals([dealId || ""]);

  useEffect(() => {
    resetPeopleInfinite();
    resetPeopleInCompany();
  }, []);

  return (
    <div className="grid grid-cols-2 gap-x-10 gap-y-8 auto-rows-auto">
      {map(orderedQuestions, (question) => (
        <SingleSelectQuestion
          key={question.id}
          question={question}
          localResponses={localResponses}
          updateResponse={updateResponse}
          questionnaireId={questionnaire.id}
          dealData={dealData}
          handleUpdateQuestionnaireScore={handleUpdateQuestionnaireScore}
          onResponseError={resetResponses}
        />
      ))}
    </div>
  );
};

export default MappingQuestionnaire;
